import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { SummaryHistoryLogsComponent } from 'src/app/core/dialogs/summary-history-logs/summary-history-logs.component';
import { BtnCellRendererDetailsDelete } from 'src/app/core/grid/btn-cell-render-details-delete';
import { SummaryService } from 'src/app/service/asn/summary.service';
import { ExcelService } from 'src/app/service/excel.service';
import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
    selector: 'app-summary-details',
    templateUrl: './summary-details.component.html',
    styleUrls: ['./summary-details.component.scss'],
    standalone: false
})
export class SummaryDetailsComponent implements OnInit {
  gridApi: any;
  successMessage: string;
  errorMessage: string;
  columnDefs = [];
  displayRowData = [];
  currentPageNo: number;
  currentPageBoolean: boolean = false;
  totalPage: number;
  currentPageForTotalPage: number;
  isLastPageFound: boolean;
  rowCount: number;
  defaultColDef: {};
  gridOptions
  icons: {};
  userID: number
  context: {};
  summaryObject: any;
  invoiceNumber: number;
  supplierNumber: number;
  isAccessible = false;
  paginationPageSize: number = 20;
	setPagination = 'true';
  @ViewChild('agGrid', { static: true }) agGrid
	dynamicHeight: number;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 20;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 20 , selected : true},
		{value: 50 , selected : false},
    {value: 'ALL' , selected : false},
	]
  constructor(private readonly router: Router, private readonly dialog: MatDialog, private readonly summaryService: SummaryService, private readonly excelService: ExcelService,
    private readonly constants: Constants, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly location: Location, private readonly exportStateService: ExportStateService) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 55;
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.columnDefs = [
      {
        headerName: "PO", field: "po", sortable: true, unSortIcon: true, width: 125,
      },
      {
        headerName: "PO LINE", field: "poLine", sortable: true, unSortIcon: true, width: 100,
      },
      {
        headerName: "BACK#", field: "backNum", sortable: true, unSortIcon: true, width: 80,
      },
      {
        headerName: "PREVIOUS QTY", field: "previousQuantity", width: 100,
      },
      {
        headerName: "SHIP QTY", field: "quantity", width: 80,
      },
      {
        headerName: "REMAINING QTY", field: "remainQuantity", width: 100,
      },
      {
        headerName: "ORIGINAL ORDER", field: "sapQuantity", width: 100,
      },
      {
        headerName: "PLANNED KG", field: "sapKg", width: 100,
      },
      {
        headerName: "SHIP KG", field: "kg", width: 80,
      },
      {
        headerName: "KG", field: "kgVariance", sortable: true, unSortIcon: true, width: 60, cellStyle: this.cellStyling
      },
      {
        headerName: "QTY", field: "quantityVariance", sortable: true, unSortIcon: true, width: 60, cellStyle: this.cellStyling
      },
      {
        headerName: "PO SCHEDULE", field: "poScheduleMatch", sortable: true, unSortIcon: true, width: 100, cellStyle: this.cellStyling
      },

      {
        headerName: "DETAILS", field: "summary_details", cellRenderer: BtnCellRendererDetailsDelete, width: 100,
      }];
    // this.checkRoles();
    this.refreshData();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }
  cellStyling(params) {
    if (params.value == "NG" || params.value == "Over") { // NOSONAR
      return { 'background-color': 'red', 'color': 'black' };
    } 
    if (params.value == "Short") { // NOSONAR
      return { 'background-color': 'yellow', 'color': 'black' };
    }
    return {}
  }
  async checkRoles() {
    await this.exportStateService.getRoles();
    const roles = this.exportStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_NAMCPlanner60EXP)
    //   ) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // } // Commented for APM
  }

  refreshData() {
    this.summaryObject = JSON.parse(localStorage.getItem('summary-details'));
    if (this.summaryObject) {
      this.invoiceNumber = this.summaryObject?.invoiceNumber;
      this.supplierNumber = this.summaryObject?.supplier;
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.summaryService.loadDataSummaryDetails(this.invoiceNumber, this.supplierNumber).subscribe(
        response => {
          if (response.length > 0) {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            this.displayRowData = response
            this.gridApi?.setGridOption('rowData', this.displayRowData);
            this.rowCount = this.displayRowData.length;
            if (this.displayRowData.length) {
              this.totalRecords = this.displayRowData.length;
              this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
              this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
              this.sRecord = 1
              this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
              if (this.cPage > this.tPage) {
                this.cPage = 1;
              }
            }
          }
          else {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            this.errorMessage = "Currently there are no details available for the selected row.";
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTimeShort);
          }

        },
        _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
        }
      );

    }
    else {
      this.errorMessage = "Error with Invoice number or Supplier.";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
    }

  }
  detailsTemplateRow(data, _pagename) {
    const dialogRef = this.dialog.open(
      SummaryHistoryLogsComponent, {
      disableClose: true,
      width: '800px',
      data: {
        header: 'History',
        eventType: 'DETAILS',
        po: data.po,
        poLine: data.poLine,
        backNum: data.backNum,
        invoiceNum: this.summaryObject.invoiceNumber,
        supplier: this.summaryObject.supplier
      }
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'SaveEvent') { // NOSONAR
        if (result.eventResponse == "Success") { // NOSONAR
          this.successMessage = this.constants.APIDataSaved;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
        }
        this.refreshData();
      }
    });
  }
  sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length)); this.updatePaginationDetails();}
    else
     { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails();}
  }

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }

  getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		event.target.value === 'ALL' ? this.gridApi?.setGridOption('paginationPageSize', this.totalRecords) : this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

  onBtExport(): void {
    if (this.displayRowData) {
      if (this.displayRowData.length > 0) {
        const exportData = [];
        this.displayRowData.forEach(e => {
          const obj = {
            PO: e.po,
            POLine: e.poLine,
            BackNum: e.backNum,
            PreviousQuantity: e.previousQuantity,
            RemainQuantity: e.remainQuantity,
            SAPQuantity: e.sapQuantity,
            PlannedKG: e.kg,
            ShipKG: e.sapKg,
            KG: e.kgVariance,
            Quantity: e.quantityVariance,
            POSchedule: e.poScheduleMatch,
          };
          exportData.push(obj);
        });

        const headers = ['PO', 'PO Line', 'Back#', 'Previous Quantity', 'Remain Quantity', 'SAP Quantity', 'Planned KG', 'Ship KG', 'KG', 'Quantity', 'PO Schedule'];
        this.excelService.exportAsExcelFile(exportData, 'ASN-SUMMARY-DETAILS', headers);
      }
    }
  }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
  openRouteLevel(route): void {
    this.router.navigate([`${route}`]);
  }
  goBack(): void {
    this.location.back();
  }
}
